import './index.scss';
import React, {useState, useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import {Button, Popconfirm,Popover, Input, Card, Breadcrumb, Icon, message, Pagination, Table, Modal, InputNumber, Progress} from 'antd';
import moment from 'moment';
import Info from '../Detail/Info';
import ajaxUtil from '../../util/ajax';
import {style} from '../../util/image';
import './ClockEditor.scss';
import URLUtil from '../../util/url';
import {debounce} from '../../util/func';
import {m3u8Parser, m3u8Segments} from '../../util/video.js';
import {fixedLength} from '../Video/Countup';
import VideoPlayer from '../VideoV2/Player';
import SwipeableViews from 'react-swipeable-views';

const {ajax, ajaxv2, DOMAIN_CURRENT} = ajaxUtil;

const timeFormat = (time, unit = 's')=>{
  let duration = moment.duration(time, unit);
  return `${fixedLength(duration.hours())}:${fixedLength(duration.minutes())}:${fixedLength(duration.seconds())}`;
}

let __timer = 0;

const ClockEditor = (props)=>{
  const {videoList} = props;
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState(null);
  const [clipList, setClipList] = useState([]);
  const [video, setVideo] = useState(null);
  const clipScrollRef = useRef(null);

  useEffect(()=>{
    setVisible(!!props.data);

    if(props.data) {
      let newData = {
        ...props.data
      };
      if(typeof newData.doc_result == 'string') {
        try {
          newData.doc_result = JSON.parse(newData.doc_result);
        }catch(e) {

        }
      }
      setData(newData);
    }
  }, [props.data]);

  useEffect(()=>{
    if(data && data.id) {
      fetchClipList();
    }
  }, [data]);

  const fetchClipList = ()=>{
    // 获取详情
    let targetVideo = videoList.find(it=>it.id == data.medium_id);
    if(targetVideo) {
      setVideo(targetVideo);
    }

    // 请求已经存在的翻页数据
    const {begin_at, end_at, cut_play_url} = targetVideo.source_detail;

    ajaxv2({
      url:'/api/v2/live/docs/clip/list',
      data:{
        id:data.id,
        start:Math.round(Date.parse(begin_at) / 1000),
        // end:Math.round(Date.parse(end_at) / 1000)
        end:Math.round(Date.parse(end_at) / 1000 + 365 * 86400 * 1000)
      }
    }).then(res=>{
      res.sort((a, b)=>{
        return a.created_at > b.created_at ? 1 : -1;
      });

      // 检查并修正数据
      let item = res[0];
      if(item && typeof item.second != 'number') {
        // 分析m3u8
        m3u8Segments(cut_play_url, '').then(m3u8=>{
          let {startTime} = m3u8;

          res = res.map(it=>{
            let between = Math.max(0, Math.round((Date.parse(it.created_at) - startTime)/1000));
            it.second = between;

            return it;
          });

          console.log(res);

          setClipList(res);
        })
      }else {
        res.sort((a, b)=>{
          return Number(a.second || 0) > Number(b.second || 0) ? 1 : -1;
        });

        setClipList(res);
      }
    })
  }

  const formatVideoTime = ()=>{
    if(video) {
      let cutUrl = URLUtil(video.source_detail.cut_play_url);
      let duration = Number(cutUrl.getParam('query_duration'));
      return timeFormat(duration);
    }

    return '--:--:--';
  }

  const [previewIndex, setPreviewIndex] = useState(0);

  const [currentStatus, setCurrentStatus] = useState('stop');
  const [currentPageTime, setCurrentPageTime] = useState(0);
  const [totalPageTime, setTotalPageTime] = useState(0);

  const onTimerHandler = ()=>{
    setCurrentPageTime(currentPageTime + 1000);
    setTotalPageTime(totalPageTime + 1000);
  };

  const getVideoTime = ()=>{
    return new Promise((resolve)=>{
      let eventName = `video_${Math.random()}`;
      let event = new Event('video-time');
      event.data = eventName;

      const handler = (evt)=>{
        console.log(`handle video time response`);
        window.removeEventListener('video-time-response-' + eventName, handler);
        resolve(evt.data);
      };

      window.addEventListener('video-time-response-' + eventName, handler);
      window.dispatchEvent(event);
    });
  }

  const addOneRecord = (index)=>{
    index = typeof index != 'undefined' ? index : previewIndex;
    getVideoTime().then(time=>{
      ajaxv2({
        url: '/api/v2/live/docs/record/add',
        method: 'post',
        data: {
          gallery_id:data.gallery_id,
          doc_id:data.id,
          current:index,
          second:time
          // second:second ? second:undefined
        }
      }).then(res => {
        setClipList([
          ...clipList,
          res
        ]);

        let {current} = clipScrollRef;
        if(current) {
          current.scrollTo(clipList.length * 150, 0);
        }
      });
    });
  }

  const debounceAddOne = debounce(addOneRecord);

  const startRecord = ()=>{
    setCurrentStatus('start');
    window.dispatchEvent(new Event('video-play'));

    debounceAddOne();
  };

  const stopRecord = ()=>{
    setCurrentStatus('stop');
    window.dispatchEvent(new Event('video-pause'));
  };

  useEffect(()=>{
    if(currentStatus == 'start') {
      __timer = setTimeout(onTimerHandler, 1000);
    }

    return ()=>{
      clearTimeout(__timer);
    }
  }, [currentStatus, currentPageTime, totalPageTime]);

  const resetRecord = ()=>{
    Modal.confirm({
      centered:true,
      title:'重置计时会清空当前记录数据，请确认是否继续？',
      okText:"确认",
      onOk:()=>{
        setCurrentPageTime(0);
        setTotalPageTime(0);
        stopRecord();

        ajaxv2({
          url:'/api/v2/live/docs/empty/' + data.gallery_id + '/' + data.id,
          method:'POST'
        }).then(res=>{
            message.success('重置成功');
            setClipList([]);
        })
      }
    })
  }

  const sortClipList = ()=>{
    let newList = [].concat(clipList);
    newList.sort((a, b)=>{
      return Number(a.second || 0) > Number(b.second || 0) ? 1 : -1;
    });

    setClipList(newList);
  };

  const [batchEditor, setBatchEditor] = useState(false);

  const renderStatusButtons = ()=>{
    return <React.Fragment>
      {currentStatus == 'stop' ? <Button icon="caret-right" onClick={startRecord}>开始</Button> : null}
      {currentStatus == 'start' ? <Button icon="pause" type="danger" onClick={stopRecord}>暂停</Button> : null}
      <div className="record-time">
        <div>当前页时间：{timeFormat(currentPageTime, 'ms')}</div>
        <div>总时长：{timeFormat(totalPageTime, 'ms')}</div>
      </div>
      <div style={{display:'flex'}}>
        <Button.Group>
          <Button icon="ordered-list" onClick={sortClipList}>排序</Button>
          <Button icon='redo' onClick={resetRecord}>重置</Button>
          <Button icon='form' onClick={()=>setBatchEditor(true)}>批量编辑</Button>
        </Button.Group>
      </div>
    </React.Fragment>;
  };

  const onPreviewIndexChange = (e)=>{
    if(e != previewIndex) {
      setPreviewIndex(e);
      if(currentStatus == 'start') {
        debounceAddOne(e);
      }
    }
  }

  const [editStyle, setEditStyle] = useState({});
  const renderEditStyle = (it)=>{
    return <TimeEditMode data={it} onCancel={()=>{
      setEditStyle({
        ...editStyle,
        [it.id]:false
      })
    }} onSubmit={(d)=>{
      setEditStyle({
        ...editStyle,
        [it.id]:false
      });

      editClip(d);
    }} />
  };

  const editClip = (d)=>{
    ajaxv2({
      url:'/api/v2/docs/clip/upone/' + d.id,
      method:'POST',
      data:{
        second:d.second,
        current:d.current
      }
    }).then(res=>{
      console.log(res);
    })
  };

  const deleteRecord = (d)=>{
    ajaxv2({
      url:'/api/v2/docs/clip/delone/' + d.id,
      method:'POST',
    }).then(res=>{
      if(res && res.id) {
        message.success('删除成功');
        setClipList(clipList.filter(it=>it.id != d.id));
      }
    })
  };

  const [showProgress, setShowProgress] = useState(false);
  const [progress, setProgress] = useState(0);
  const onBatchEdit = (value)=>{
    if(showProgress) {
      return;
    }

    setShowProgress(true);
    setProgress(0);

    // 处理一下数据
    let array = (value || '').split(/\n/).filter(Boolean);

    array = array.map(it=>{
      let arr = it.split(',');
      let second = 0;
      let timeArr = arr[1] ? arr[1].split(':') : [0,0,0];
      if(timeArr && timeArr.length >=3) {
        second = Number(timeArr[0]) * 3600 + Number(timeArr[1]) * 60 + Number(timeArr[2]);
      }

      return {
        gallery_id:data.gallery_id,
        doc_id:data.id,
        current:Number(arr[0]),
        second:Number(second)
      };
    });

    // 开始添加
    let total = array.length;
    const batchAddOne = (arr)=>{
      let one = arr.shift();
      ajaxv2({
        url: '/api/v2/live/docs/record/add',
        method: 'post',
        data: one
      }).then(res => {
        setProgress(Math.round((total - arr.length) * 100 / total));

        if(arr.length <= 0) {
          // 已经执行完了
          setShowProgress(false);
          fetchClipList();

          message.success('批量修改成功');
          setBatchEditor(false);
        }else {
          batchAddOne(arr);
        }
      });
    };

    // 先清理所有
    ajaxv2({
      url:'/api/v2/live/docs/empty/' + data.gallery_id + '/' + data.id,
      method:'POST'
    }).then(res=>{
      batchAddOne(array);
    });
  }

  return <Modal visible={visible} width={818} title={'计时设置'} wrapClassName="clock-editor" centered={true} maskClosable={false} onCancel={()=>{
    props.onCancel && props.onCancel();
  }} onOk={()=>{
    props.onSubmit && props.onSubmit(data);
  }}>
    <div className="wrapper">
      <div className="header">
        <Info label="视频总时长" isText={true} value={formatVideoTime()} />
      </div>
      <div className="preview">
        <div className="preview-video">
          {video ? <VideoPlayer source={video} /> : null}
        </div>
        {data && data.doc_result ? <div className="preview-docs">
          <SwipeableViews enableMouseEvents index={previewIndex} onChangeIndex={onPreviewIndexChange} disableLazyLoading={false}>
            {(data.doc_result || []).filter(Boolean).map((file, index)=>{
              return <div key={file} className="bigpic-one">
                {Math.abs(previewIndex - index) < 2 ?
                  <img src={style(file, 'wx_image_1')}/> :
                  null}
                <span className="index">{index+1}</span>
              </div>;
            })}
          </SwipeableViews>
          <div className="arrows">
            {previewIndex > 0 ? <Icon type="left-circle" theme="filled" style={{fontSize:36, background:'rgba(255, 255, 255, 0.5)', borderRadius:'18px 18px'}} onClick={()=>{
              onPreviewIndexChange(Math.max(0, previewIndex - 1));
            }} /> : <div/>}
            {previewIndex < data.doc_result.length - 1 ? <Icon type="right-circle" theme="filled" style={{fontSize:36, background:'rgba(255, 255, 255, 0.5)', borderRadius:'18px 18px'}} onClick={()=>{
              onPreviewIndexChange(Math.min(data.doc_result.length - 1, previewIndex + 1));
            }} /> : <div/>}
          </div>
        </div> : null}
      </div>
      <div className="info">
        {renderStatusButtons()}
      </div>
      <div className="controls" ref={clipScrollRef}>
        {clipList && clipList.length ? clipList.map((it,index)=>{
          return <div className="doc-item" key={it.id}>
            <div className="realitem">
              {/*<div className="left-click" onClick={()=>addOneRecordByIndex(it, index, -1)}>+</div>*/}
              <div className="image">
                <img src={style(data.doc_result[it.current], 'wx_image_2')} />
                <div className='index'>{Number(it.current)+1}</div>
              </div>
              {/*<div className="right-click" onClick={()=>addOneRecordByIndex(it, index, 1)}>+</div>*/}
              <div className="operation">
                {/*<a onClick={()=>setEditStyle({
                  ...editStyle,
                  [it.id]:true
                })}>编辑</a>*/}
                <a onClick={()=>deleteRecord(it)}>删除</a>
              </div>
            </div>
            <div className="time">
              {editStyle[it.id] ? renderEditStyle(it) : timeFormat(it.second, 's')}
            </div>
          </div>;
        }) : '暂无数据'}
      </div>

      <BatchEditModal list={clipList} visible={batchEditor} onCancel={()=>setBatchEditor(false)} onSubmit={onBatchEdit} />
      <Modal visible={showProgress} centered={true} maskClosable={false} footer={null} closable={false}>
        <div className="wrapper">
          <p>正在处理中，请勿关闭浏览器，直到处理完成</p>
          <Progress percent={progress} />
        </div>
      </Modal>
    </div>
  </Modal>
};

const TimeEditMode = (props)=>{
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);
  const [second, setSecond] = useState(0);

  const {data, onCancel, onSubmit} = props;

  useEffect(()=>{
    if(data) {
      let [hour1, minute1, second1] = decodeTime(Number(data.second));
      setHour(hour1);
      setMinute(minute1);
      setSecond(second1);
    }
  }, []);

  const decodeTime = (time)=>{
    let duration = moment.duration(time, 's');

    return [duration.hours(), duration.minutes(), duration.seconds()];
  };

  const encodeTime = ()=>{
    return hour * 3600 + minute * 60 + second;
  };

  return <div className="time-edit">
    <Input
      value={(hour)}
      size="small"
      formatter={fixedLength}
      onChange={(e)=>{
        setHour(Number(e.target.value));
      }}
    />
    <span class="spec">:</span>
    <Input
      value={(minute)}
      size="small"
      onChange={(e)=>{
        console.log(e);
        setMinute(Number(e.target.value));
      }}
    />
    <span class="spec">:</span>
    <Input
      value={(second)}
      size="small"
      onChange={(e)=>{
        setSecond(Number(e.target.value));
      }}
    />
    <Icon type="check" onClick={()=>{
      onSubmit({
        ...data,
        second:encodeTime()
      });
    }} />
    <Icon type="close" onClick={onCancel} />
  </div>;
};

const BatchEditModal = (props)=>{
  const {list, onCancel, onSubmit, visible} = props;

  const [value, setValue] = useState('');
  useEffect(()=>{
    if(visible) {
      let newList = [].concat(list);
      newList.sort((a, b)=>{
        return Number(a.second || 0) > Number(b.second || 0) ? 1 : -1;
      });
      setValue(newList.map(it=>{
        return `${Number(it.current) + 1},${timeFormat(it.second)}`;
      }).join('\n'));
    }
  }, [list, visible]);

  return <Modal centered={true} maskClosable={false} title="批量编辑" onCancel={onCancel} onOk={()=>{
    Modal.confirm({
      title:'是否确认开始批量修改计时？',
      content:'该过程需要几分钟时间，期间不能关闭浏览器',
      centered:true,
      onOk:()=>{
        onSubmit(value);
      },
      okText:'确认'
    })
  }} visible={visible}>
    <div className="wrapper">
      <p style={{color:'#666'}}>格式为：PPT页数, 对应的时间</p>
      <Input.TextArea autoSize={{minRows:10, maxRows:20}} autoSize={{minRows:10, maxRows:20}} style={{width:'100%'}} value={value} onChange={(e)=>{
        setValue(e.target.value);
      }} />
    </div>
  </Modal>
};

export default ClockEditor;



// WEBPACK FOOTER //
// ./src/components/Document/ClockEditor.js